import LeopardTree from './components/LeopardTreee.vue'

const components = {
  install(Vue){
    Vue.component("LeopardTree", LeopardTree)
  }
}

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(components)
}

export default components



// WEBPACK FOOTER //
// ./src/lib/index.js